<template>
  <!-- .live-act-->
  <div class="live-act" :class="isLive ? 'ly' : ''">
    <template v-if="dataList.length">
      <List v-model="loading" :finished="finished" @load="loadMore" class="my-box">
        <div class="rc" v-for="(item, index) in dataList" :key="'rank2-' + index">
          <div class="rc-row s-left" @click="LinkAct(item)">
            <div class="rc-row-box">
              <!-- 列表 -->
              <div class="rc-item">
                <!-- 头像 -->
                <div class="rc-img-box">
                  <img v-if="item.banners[0]" :src="item.banners[0]" :class="{'s-square': false}" v-load="'oActSmall'" />
                  <img
                    v-else
                    src="@/assets/img/empty.png"
                    class="empty-img"
                    :class="{'s-square': false}"
                  />
                </div>

                <div class="rc-test">
                  <p class="rc-test-title">
                    <span class="rc-test-title-txt" :class="!item.hasLive ? 'max-txt' : ''">{{item.title}}</span>
                    <span class="my-brand dot" v-if="item.hasLive && item.liveAuditState === 'PASS' && item.liveStateIndex == 1">直播中</span>
                    <span class="my-brand icon s-blue" v-if="item.hasLive && item.liveAuditState === 'PASS' && item.liveStateIndex == 2">
                      <span class="icon iconfont icon-zhibo"></span>有直播
                    </span>
                    <span class="my-brand s-gray" v-if="item.hasLive && item.liveAuditState === 'PASS' && item.liveStateIndex == 3">直播回看</span>
                  </p>
                  <p class="rc-test-time">{{item.startTime | moment('MM/DD HH:mm')}}</p>
                  <p class="rc-test-comp" v-if="item.company">{{item.company.name}}</p>
                  <!-- 统计数据显示 -->
                  <div class="rc-test-main z-padd">
                    <!-- 分享数 -->
                    <div class="brand">
                      <span>
                        <i class="icon iconfont icon-fenxiang2"></i>
                        {{$service.getCount(item.shareCount)}}
                      </span>
                    </div>
                    <!-- 浏览数 -->
                    <div class="brand">
                      <span>
                        <i class="icon iconfont icon-guankan2"></i>
                        {{$service.getCount(item.viewCount)}}
                      </span>
                    </div>
                    <!-- 关注数 -->
                    <div class="brand">
                      <span>
                        <i class="icon iconfont icon-huabanfuben"></i>
                        {{$service.getCount(item.followCount)}}
                      </span>
                    </div>
                    <!-- 关注数 -->
                    <div class="brand">
                      <span style="color:#f85b0f;">
                        <i class="icon iconfont icon-huo"></i>
                        {{$service.getCount(item.power)}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </template>
    <div class="u-empty" v-else>暂无数据！</div>
    <div style="height: 49px"></div>
  </div>
</template>

<script>
import { List } from "vant";
import { mapActions, mapGetters} from "vuex";
import gql from 'graphql-tag'
export default {
  name: "live-act",
  props:['isLive'],
  data() {
    return {
      loading: false,
      finished: false,
      active: 0,
      dataList:[],
      pageIndex:1,
      pageSize:10,
      queryActivity:{},
    };
  },
  components: {
    List,
  },
  computed:{
    ...mapGetters({
      exhibitionId:'getExhibitionId',
    }),
    ActGql(){ // 查询展商的活动
      return gql`query queryActivity($query:QueryInput!,$exhibitionId: Guid){
            queryActivity(query: $query,exhibitionId: $exhibitionId){
                hasNextPage
                hasPreviousPage
                pageIndex
                pageSize
                totalCount
                totalPages
                items{
                  acvitityType
                  banners
                  exhibitionId
                  exhibitorId
                  followCount
                  company{
                    name
                  }
                  id
                  likeCount
                  shareCount
                  startTime
                  stateIndex
                  title
                  userCount
                  viewCount
                  liveStateIndex
                  liveAuditState
                  hasLive
                  power
                }
            }
          }`
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      LinkAct:'linkTo/LinkAct2',
    }),
    init(){
      this.getActByExtr();
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      console.log(this.pageIndex,'当前加载的页面')
      this.getActByExtr();
    },
    getActByExtr(){ // 获取展商的活动
      let where = {
          "Equal":{
            "n":"exhibitionId",
            "v":this.exhibitionId
          },
          "notEqual2":{
            "n":"exhibitorId",
            "v":''
          },
      }
      let order=[
        {
          "N":"power",
          "v":0
        },
        {
          "N":"createAt",
          "v":0
        },
      ]
      this.$apollo.addSmartQuery('queryActivity', {
        query:this.ActGql, 
        variables: {
          query:{
            page:this.pageIndex,
            size:this.pageSize,
            where:JSON.stringify(where),
            order:JSON.stringify(order)
          },
          exhibitionId:this.exhibitionId
        },
        fetchPolicy:'no-cache',
        result(data) {
          let res = JSON.parse(JSON.stringify(data))
          if(res.data.queryActivity.items){
              let currentList = res.data.queryActivity.items;
              currentList.map(c=>{
                if(c.banners.indexOf('[') !== -1){
                  c.banners =  JSON.parse(c.banners);
                } else {
                  if(c.banners){
                    c.banners = [c.banners]
                  } else {
                    c.banners = []
                  }
                }
              })
              if(this.pageIndex == 1){
                this.dataList = currentList;
              } else {
                this.dataList = [...this.dataList,...currentList]
              }
              this.loading = false;
              if (!res.data.queryActivity.hasNextPage) {
                this.finished = true;
              }
          }
        },// 错误处理
        error(error) {
            console.error(error,'error错误处理')
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.ly{
  overflow-y: auto;
}
.more {
  background-color: #fff;
  margin-bottom: 15px;
  .nav-left {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    width: 50%;
    display: flex;
    align-items: center;
    padding-left: 15px;
  }
  .tab-active{
    color: #ff5c00;
    position: relative;
  }
  .tab-active::after{
    content: "";
    position: absolute;
    left:0;
    right: 0;
    bottom: 0;
    margin:auto;
    width: 34px;
    height: 2px;
    background-color: #ff5c00;
    border-radius: 1px;
  }
}
.live-act{
  padding-left: .3rem;
}
.rc {
  width: 100%;
  border-bottom: 1px solid rgb(240, 240, 240);
  background: #fff;
  // margin-left: .3rem;
  &-item {
    display: flex;
    flex: 1;
    min-height: 70px;
    &-blist {
      z-index: 2;
      position: relative;
      &_one {
        img {
          width: 100%;
        }
        p {
          font-size: 13px;
          margin-top: 6px;
          margin-bottom: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    &-bact {
      z-index: 2;
      position: relative;
      .rc-row2_item {
        margin-bottom: 10px;
        font-size: 12px;
        color: #666;
        line-height: 1.5;
        &:only-child,
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    &-bottom {
      border-radius: 2px;
      width: 100%;
      background-color: #fff;
      box-shadow: 0px 0px 8px 0px rgba(149, 152, 155, 0.3);
      position: relative;
      z-index: 3;
      padding: 10px;
      margin-top: 5px;
      &:before {
        content: "";
        width: 10px;
        height: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 8px 0px rgba(149, 152, 155, 0.3);
        transform: rotate(45deg);
        position: absolute;
        top: -5px;
        left: 20px;
        z-index: -1;
      }
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #fff;
        z-index: 1;
        border-radius: 2px;
      }
    }
  }
  .rc-row {
    padding: .3rem .6rem .28rem 0;
    height: auto;
    &.s-left {
      padding-left: 0;
    }
    &-box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .rc-index {
      min-width: 30px;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      position: relative;
      padding-top: 20px;
      padding-left: 5px;
    }
    .rc-img-box {
      position: relative;
      display: inline-block;
      flex-shrink: 0;
      width: 2.2rem;
      height:1.24rem;
      border-radius: 5px;
      border: solid 1px #e6e6e6;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        &.empty-img {
          opacity: 1;
          width: 100%;
          height: auto;
          position: absolute;
          margin: auto;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
    .rc-test {
      width: calc(100% - 2.2rem);
      margin-left: 10px;
      flex-direction: column;
      &-title {
        font-weight: 600;
        font-size: 0.26rem;
        display: flex;
        align-items: center;
        line-height: 1.5;
        .my-brand {
          line-height: initial;
          width: 0.88rem;
          height: 0.3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
            linear-gradient(#000, #000);
          background-blend-mode: normal, normal;
          border-radius:0.05rem;
          color: #fff;
          font-size: 0.18rem;
          vertical-align: middle;
          margin-right: 4px;
          &.dot {
            &::before {
              content: "";
              display:block;
              width: 0.12rem;
              height: 0.12rem;
              border-radius: 50%;
              background-color: #fff;
              margin-right: 0.06rem;
            }
          }
          &.s-blue {
            background-image: linear-gradient(90deg, #56ccf2 0%, #2f80ed 100%),
              linear-gradient(#000, #000);
          }
          &.s-gray{
            background-image: linear-gradient(90deg, 
            #ffc659 0%, 
            #ffa751 100%), 
              linear-gradient(
            #000, 
            #000);
          }
        }
        &-txt {
          display: inline-block;
          max-width: 3rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // margin-right: 10px;
        }
        .max-txt{
          max-width: 4.5rem;
        }
      }
      &-Entitle {
        font-size: 12px;
        font-weight: normal;
      }
      &-time{
        font-size: .2rem;
        line-height: 1.5;
        color: #666;
      }
      &-comp{
        font-size: .22rem;
        line-height: 1.5;
        color: #666;
      }
      &-booth {
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 16px;
        .rc-border {
          font-size: 12px;
          color: rgb(102, 102, 102);
          margin-right: 5px;
          position: relative;
          display: inline;
          padding: 1px 3px 1px 0;
        }
        .rc-booth {
          position: relative;
          margin-left: -3px;
        }
        .icon {
          font-size: 20px;
          position: relative;
          top: 3px;
          margin-left: -3px;
          display: inline-block;
        }
        .icon-dizhi {
          color: #fe781d;
        }
        .icon-biaoqian1 {
          color: #1890ff;
        }
      }
      &-main {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 8px;
        color: rgb(102, 102, 102);
        position: relative;
        left: -3px;
        .brand {
          line-height: 1.2;
          margin-right: 8px;
          &.z-right {
            justify-self: flex-end;
            flex: 1;
            span {
              display: inline-block;
              width: 100%;
              text-align: right;
            }
          }
          span {
            color: #999;
            line-height: 18px;
            display: inline-block;
            display: flex;
            align-items: center;
            font-size: .22rem;
            .icon-dianzan,
            .icon-guanzhu {
              font-size: 12px;
            }
            .icon-zhiboguankanshu {
              position: relative;
              top: 1px;
            }
            .icon-guanzhu {
              position: relative;
              top: -1px;
            }
          }
          .iconfont {
            font-size: .3rem;
            display: inline-block;
            margin-right: 2px;
          }
        }
        &.z-padd {
          margin: 0;
        }
        .ranking-conten-guanKan {
          display: inline-block;
          width: 16px;
          height: 14px;
          position: relative;
          top: 3px;
          margin-right: 2px;
        }
        .rc-border {
          border: 1px solid rgb(230, 230, 230);
          border-radius: 2px;
          margin-right: 5px;
          padding: 1px 2px;
          display: inline-block;
          max-width: 100%;
          overflow: hidden;
          line-height: 1.2;
          .icon {
            font-size: 12px;
            position: relative;
            left: 1px;
          }
          span {
            position: relative;
            left: -2px;
          }
          &.z-padd {
            padding: 1px 3px 1px 0;
          }
        }
      }
      .rc-row2 {
        margin-top: 4px;
        color: #666;
        line-height: 20px;
        font-size: 12px;
        color: rgb(102, 102, 102);
        &_item {
          margin-bottom: 5px;
          word-break: break-all;
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>